import React from "react";
import styled from "styled-components";

const AccentTitleContainer = styled.p`
  font-size: 13px;
  line-height: 14.87px;
  letter-spacing: 0.8px;
  padding-top: 12px;
  margin-top: ${({ $marginTop }) => $marginTop || "25px"};
  margin-bottom: 5px;
  text-transform: uppercase;
  color: ${({ theme, $colour = "grey" }) => theme.colours[$colour]};

  a {
    color: ${({ theme, $colour = "grey" }) => theme.colours[$colour]};
    text-decoration: none;
    &:hover {
      color: ${({ theme }) => theme.colours.blue};
    }
  }
`;

function AccentTitle({
  children,
  marginBottom,
  marginTop,
  decorated,
  colour,
  ...props
}) {
  return (
    <AccentTitleContainer
      $colour={colour}
      $marginBottom={marginBottom}
      $marginTop={marginTop}
      $decorated={decorated}
      {...props}
    >
      {children}
    </AccentTitleContainer>
  );
}

export default AccentTitle;
